import { render } from "./MobileJiaxing.vue?vue&type=template&id=360cb909&scoped=true"
import script from "./MobileJiaxing.vue?vue&type=script&lang=js"
export * from "./MobileJiaxing.vue?vue&type=script&lang=js"

import "./MobileJiaxing.vue?vue&type=style&index=0&id=360cb909&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-360cb909"]])

export default __exports__